import { removeFocus, addFocus } from '../helpers/focus-elements';

(() => {
  const searchDropdown = document.querySelector('.g02');

  if (searchDropdown === null) {
    return;
  }

  let isSearch = false;

  const searchButtons = document.querySelectorAll('[data-search-button]');
  const searchWrap = document.querySelector('.g01__search-wrap');
  const searchInput = searchDropdown.querySelector('.g02__search');

  const searchElements = searchDropdown.querySelectorAll('input, select, button');
  removeFocus(searchElements);

  searchButtons.forEach(button => {
    button.addEventListener('click', () => {
      isSearch = ! isSearch;

      searchWrap.classList[isSearch ? 'add' : 'remove']('is-active');
      document.body.classList[isSearch ? 'add' : 'remove']('is-search');

      searchDropdown.setAttribute('aria-hidden', ! isSearch);

      if (isSearch) {
        removeFocus(searchElements);
        searchInput.focus();
      } else {
        addFocus(searchElements);
        searchInput.blur();
      }
    });
  });

  const searchClose = searchDropdown.querySelector('.g02__close');
  searchClose.addEventListener('click', () => {
    isSearch = false;
    searchWrap.classList.remove('is-active');
    document.body.classList.remove('is-search');
    searchDropdown.setAttribute('aria-hidden', true);
    removeFocus(searchElements);
    searchInput.blur();
  });
})();